<template>
  <div>
    <v-select
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="cameraOptions"
      v-model="selectedCameras"
      :multiple="true"
      :closeOnSelect="false"
      label="label"
      :clearable="true"
      @search="onSearch"
      @input="updateSelected"
      :disabled="disabled"
    >
      <template #no-options>
        <div class="custom-no-options">
          {{ $t("installation_components.no_options_found") }}
        </div>
      </template>

      <template #search="{ attributes, events }">
        <input class="vs__search" v-bind="attributes" v-on="events" />
      </template>

      <li slot="list-footer" class="pagination">
        <b-button v-if="showPrevButton" variant="outline-secondary" @click="prevPage">
          {{ $t("installation_components.previous") }}
        </b-button>
        <b-button v-if="showNextButton" variant="outline-secondary" @click="nextPage">
          {{ $t("installation_components.next") }}
        </b-button>
      </li>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { BButton } from "bootstrap-vue";
import axios from "@axios";

export default {
  name: "SelectPaginateCamera",
  components: {
    vSelect,
    BButton,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    ids_tenant: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCameras: [],
      search: "",
      page: 1,
      lastPage: 1,
      cameraOptions: [],
      baseUrl: `${window.__env.VUE_APP_BASE_URL}/v1/proxy_camera`,
    };
  },
  computed: {
    showPrevButton() {
      return this.page > 1;
    },
    showNextButton() {
      return this.page < this.lastPage;
    },
  },
  methods: {
    updateSelected(val) {
      this.selectedCameras = val;
      const selectedIds = val.map(item => item.value);
      this.$emit("update:selected", selectedIds);
    },
    onSearch(query) {
      this.page = 1;
      this.search = query;
      this.fetchCameras();
    },
    nextPage() {
      if (this.page < this.lastPage) {
        this.page++;
        this.fetchCameras();
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchCameras();
      }
    },
    fetchCameras() {
      const params = {
        "page[n]": this.page,
        max: 20,
        q: this.search,
        sortBy: "id",
        sortDesc: true,
        "with[]": "units",
      };

      if (this.ids_tenant.length) {
        params["tenant[]"] = this.ids_tenant;
      }

      return axios
        .get(this.baseUrl, { params })
        .then(res => {
          const data = res.data.data || res.data;
          const meta = res.data.meta || {};

          this.cameraOptions = data.map(item => ({
            value: item.camera.camera_proxy_id,
            label: item.camera.name,
          }));

          this.lastPage = meta.last_page || 1;
          this.syncSelected();
        })
        .catch(console.error);
    },
    syncSelected() {
      const currentIds = this.selected.map(id => parseInt(id));

      this.selectedCameras = this.cameraOptions.filter(cam =>
        currentIds.includes(cam.value)
      );

      currentIds.forEach(id => {
        if (!this.selectedCameras.find(c => c.value === id)) {
          this.selectedCameras.push({
            value: id,
            label: `Camera ID ${id}`,
          });
        }
      });
    },
  },
  mounted() {
    this.fetchCameras();
  },
  watch: {
    ids_tenant() {
      this.page = 1;
      this.fetchCameras();
    },
    selected() {
      this.syncSelected();
    },
    
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
  justify-content: space-between;
}
.pagination button {
  flex-grow: 1;
}
</style>
